import { useEffect, useState } from "react";
import { useApi } from "@/context/ApiContext";
import {
  ensureProviderInfos,
  type ProviderInfos,
} from "@/lib/provider-infos";

/** Cached `configurable.providers` payload for account/market metadata. */
export function useProviderInfos() {
  const api = useApi([]);
  const [infos, setInfos] = useState<ProviderInfos | null>(null);

  useEffect(() => {
    let cancelled = false;
    ensureProviderInfos(api.commands)
      .then((i) => {
        if (!cancelled) setInfos(i);
      })
      .catch(() => {
        // Old backends — callers fall back to defaults.
      });
    return () => {
      cancelled = true;
    };
  }, [api]);

  return infos;
}
